import { Box, Button, ButtonColorVariant, GridDisplay } from '@gousto-internal/citrus-react'
import React from 'react'

type OrderTileActionsProps = {
  helpCta: string | null
  isManageDeliveryExpanded: boolean
  orderState: string
  orderStateTitle: string
  onChooseRecipesClick: () => void
  onGetHelpClick: () => void
  onManageDeliveryClick: () => void
}

export const OrderTileActions = ({
  helpCta,
  isManageDeliveryExpanded,
  orderState,
  orderStateTitle,
  onChooseRecipesClick,
  onGetHelpClick,
  onManageDeliveryClick,
}: OrderTileActionsProps) => {
  const lowerCasedOrderStateTitle = orderStateTitle.toLowerCase()
  const recipeActionConfig =
    orderState === 'choose'
      ? {
          colorVariant: ButtonColorVariant.Primary,
          label: 'Choose recipes',
        }
      : orderState === 'edit'
      ? {
          colorVariant: ButtonColorVariant.Secondary,
          label: 'Add or swap recipes',
        }
      : orderState === 'cancelled' ||
        lowerCasedOrderStateTitle.includes('cancelled') ||
        lowerCasedOrderStateTitle.includes('skipped')
      ? {
          colorVariant: ButtonColorVariant.Primary,
          label: 'Restore order',
        }
      : null
  const shouldShowRecipeActionButton = Boolean(recipeActionConfig)
  const helpButtonLabel = helpCta ?? (orderState === 'dispatched' ? 'Get help' : null)
  const shouldShowHelpButton = Boolean(helpButtonLabel) && !shouldShowRecipeActionButton
  const manageDeliveryButtonVariant =
    orderState === 'premenu' ? ButtonColorVariant.Secondary : ButtonColorVariant.Tertiary

  return (
    <Box
      display={GridDisplay.Grid}
      gridTemplateColumns={['1fr', '1fr', 'repeat(2, minmax(0, 1fr))']}
      gap={4}
    >
      {recipeActionConfig ? (
        <Button
          colorVariant={recipeActionConfig.colorVariant}
          onClick={onChooseRecipesClick}
          width="100%"
          data-testid="recipe-action-button"
          data-color-variant={recipeActionConfig.colorVariant}
        >
          {recipeActionConfig.label}
        </Button>
      ) : null}
      {shouldShowHelpButton ? (
        <Button colorVariant={ButtonColorVariant.Secondary} onClick={onGetHelpClick} width="100%">
          {helpButtonLabel}
        </Button>
      ) : null}
      <Box display={['none', 'none', 'block']}>
        <Button
          colorVariant={manageDeliveryButtonVariant}
          onClick={onManageDeliveryClick}
          width="100%"
          afterIcon={isManageDeliveryExpanded ? 'chevron_up' : 'chevron_down'}
          data-testid="manage-delivery-button"
          data-color-variant={manageDeliveryButtonVariant}
        >
          Manage delivery
        </Button>
      </Box>
    </Box>
  )
}
